// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__+MZPq","isPrimary":"Button_isPrimary__s0K9e"};